import TcVod from 'vod-js-sdk-v6';
import axios from 'axios';

function getSignature() {
    return axios.post('/sday/vod-sts', JSON.stringify({
        "Action": "GetUgcUploadSign"
    })).then(function (response) {
        return response.data
    })
}

const tcVod = new TcVod({
	getSignature: getSignature // 前文中所述的获取上传签名的函数
});

export { tcVod }